import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { IVorlagenQueryShapes, IVorlagenResponse, VorlagenQueryFilterConfig } from 'fa-kt.types';
import { VorlagenService } from '../service';

@Component({
  selector: 'fa-kt-vorlagen-filter',
  templateUrl: './vorlagen-filter.component.html',
  styleUrls: ['./vorlagen-filter.component.css'],
})
export class VorlagenFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public VorlagenFilterConfig: IFilterConfig<IVorlagenResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public vorlagen: VorlagenService,
  ) {
    this.VorlagenFilterConfig = VorlagenQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.vorlagen.shapes$.subscribe((shapes: IVorlagenQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.VorlagenFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.VorlagenFilterConfig[index].selections = shapes;
  }
}
